import { useEffect, useRef, useState } from "react"
import { Formik } from "formik"
import { Input } from "reactstrap"
import * as Yup from "yup";
import _ from "lodash";
import "./LeftPanelPaymentSection.scss"
import { useDispatch, useSelector } from "react-redux";
import { isMainDomain, SessionKeys } from "../../../../utils/AppUtils";
import { checkEmailExists, checkEmailExistsClear, getProvinceMasterData, getProvinceMasterDataClear } from "../../../../redux/user/actions";
import Country from "../../../../data/country.json";
import { Elements } from "@stripe/react-stripe-js";
import CONFIG from "../../../../utils/config";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import StripePaymentPanel from "../StripePaymentPanel/StripePaymentPanel";
import useLogin from "../../../../custom-hooks/useLogin";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import InputPhone from "react-phone-number-input/input";
import API_LIST from "../../../../utils/apiList";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../../../utils/routeList";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../../utils/SvgComps";

import { isAndroid, isIOS } from "react-device-detect";
// import InputPhoneComponent from "./InputPhoneComponent";

const stripePromise = loadStripe(CONFIG.KEY.STRIPE_KEY);

const LeftPanelPaymentSection = (props) => {

    const {
        paymentIntentInfo, setProvince, setEmail,
        paymentInProcess, setPaymentInProcess,
        submitForm, setSubmitForm,
        enableFormField, setEnableFormField, setErrorMsg, type, isMobile, 
        couponCode, isCouponApplied, shouldRedeem
    } = props


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoggedIn, userData } = useLogin()

    const [userDataUpdated, setUserDataUpdated] = useState();

    const formRef = useRef();
    const stripeRef = useRef();

    const provinceMaster = useSelector((state) => state.user.provinceMaster);
    const isEmailExists = useSelector((state) => state.user.checkEmailExists);

    const [value, setValue] = useState('')
    const [isCustomer, setIsCustomer] = useState(false)
    const [provinceList, setProvinceList] = useState([]);
    const [isEmailPresent, setIsEmailPresent] = useState(false)
    const [loginModal, setLoginModal] = useState(false)
    const [loginRedirectURL, setLoginRedirectURL] = useState('')
    const [initialValues, setInitialValues] = useState({
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "ON",
        postalCode: "",
        country: "CA",
        contactEmail: "",
        brokerage_email: "",
        brokerageName: "",
        phoneNumber: "",
        is_agreed: false
    });

    const contactEmail = Yup.string().required('Please enter your email')
        .email('Please input a valid email')

    const validationSchema = Yup.object().shape({
        contactEmail: contactEmail,
        // contactEmail: Yup.string().required("Please enter your email").email(),
        // .test('checkEmailUnique', 'This email is already registered.',
        // async (value) => {
        //     return await checkEmailExists(value)
        // }),
        firstName: Yup.string().required("Please enter your full name"),
        lastName: Yup.string().optional(),
        addressLine1: Yup.string().required("Please enter your address"),
        addressLine2: Yup.string().optional(),
        brokerageName: Yup.string().optional(),
        brokerageEmail: Yup.string().email("Please enter a valid brokerage email").optional(),
        city: Yup.string().required("Please enter your city"),
        state: Yup.string().required("Please select a state"),
        phoneNumber: Yup.string().required("Please enter your phone number"),
        postalCode: Yup.string()
            // .matches(
            //   /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
            //   "Invalid pincode"
            // )
            .required("Please enter a pincode"),
        country: Yup.string().required("Please select a country"),
    });

    useEffect(() => {
        setUserDataUpdated(userData)
    }, [userData]);

    useEffect(() => {
        dispatch(getProvinceMasterData({
            'module': 'getProvinceMaster',
            postData: {}
        }))
    }, [dispatch])

    useEffect(() => {
        if (!_.isEmpty(isEmailExists)) {
            if (isEmailExists.status === 'success') {
                console.log('EMAIL EXISTS');
                // setEnableFormField(false)
                setIsEmailPresent(true)
                setLoginModal(true)
                setLoginRedirectURL(isEmailExists.payload?.data?.domain)
            } else {
                console.log('EMAIL DOES NOT EXISTS')
                // setEnableFormField(true)
                setIsEmailPresent(false)
                setLoginModal(false)
            }
            dispatch(checkEmailExistsClear())
        }
    }, [isEmailExists])

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("token");

    const userDetailRes = useSelector((state) => state.user.userBroker);
    useEffect(() => {
        if (!_.isEmpty(userDetailRes?.payload?.payload)) {
            setUserDataUpdated(userDetailRes?.payload?.payload)
        }
    }, [userDetailRes]);

    // useEffect(() => {
    //     if (!_.isEmpty(initialValues) && initialValues.firstName && !paymentIntentInfo.isLoading) {
    //         const initVal = _.cloneDeep(initialValues)
    //         initVal.brokerageEmail = paymentIntentInfo.brokerageEmail
    //         setInitialValues(initVal)
    //     }
    // }, [paymentIntentInfo, initialValues])

    useEffect(() => {
        if (!_.isEmpty(provinceMaster) && !paymentIntentInfo.isLoading) {
            if (provinceMaster.status === 'success') {
                const plist = provinceMaster.payload.payload
                if (!_.isEmpty(plist)) {
                    if (isLoggedIn || token) {
                        if (!_.isEmpty(userDataUpdated)) {
                            let isCus = false;
                            if (userDataUpdated.roles.includes('customer')) {
                                isCus = true;
                                setIsCustomer(isCus)
                            }
                            let initValues = {
                                firstName: userDataUpdated.firstname,
                                lastName: userDataUpdated.lastname,
                                addressLine1: "",
                                addressLine2: "",
                                city: userDataUpdated.office_city,
                                state: "ON",
                                postalCode: "",
                                country: "CA",
                                is_agreed: false,
                                contactEmail: userDataUpdated.email,
                                phoneNumber: "",
                                brokerageEmail: paymentIntentInfo.brokerageEmail,
                                brokerageName: isCus ? "" : userDataUpdated.broker_name,
                            }
                            
                            console.log('USER DATA', userData)
                            for (let p of plist) {
                                
                                if (p.name === userDataUpdated.office_province) {
                                    initValues.state = p.id
                                    setProvince(p.id);
                                }
                            }
                            console.log('INIT DATA', initValues)
                            setInitialValues(initValues)
                        }
                    }
                    setProvinceList(plist)
                }
            }
            dispatch(getProvinceMasterDataClear())
        }
    }, [provinceMaster, paymentIntentInfo, userDataUpdated])

    useEffect(() => {
        if (submitForm && formRef.current) {
            setSubmitForm(false)
            if (!isEmailPresent) {
                formRef.current.handleSubmit()
            } else {
                setLoginModal(true)
            }
        }
    }, [submitForm])

    const renderCardElements = () => {
        return (
            <Elements stripe={stripePromise}>
                <StripePaymentPanel
                    ref={stripeRef}
                    paymentIntentInfo={paymentIntentInfo}
                    setPaymentInProcess={setPaymentInProcess}
                    enableFormField={enableFormField}
                    setErrorMsg={setErrorMsg}
                    type={type}
                    isMobile={isMobile}
                    couponCode={couponCode}
                    isCouponApplied={isCouponApplied}
                    shouldRedeem={shouldRedeem}
                />
            </Elements>
        )
    }

    const renderLoginButtonModal = () => {
        return (
            <Modal
                show={loginModal} onHide={() => setLoginModal(false)}
                size="500px"
                aria-labelledby="contained-modal-title-vcenter"
                className="alert-modal" centered
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="invalidemailshowfp">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
                        <path d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z" fill="#2d2d2d" />
                    </svg>
                    Email ID is already registered, please login to proceed.
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <FormButtonComponent
                        btnName={'Sign in'}
                        rightIcon={<RightArrowIcon />}
                        btnAction={() => {
                            if (isAndroid || isIOS) {
                                try {

                                    if (window.callbackHandler != undefined) {
                                        window.callbackHandler.postMessage("sign-in-from-checkout");
                                    }
                                    if (window.webkit != undefined) {
                                        if (
                                            window.webkit.messageHandlers.callbackHandler !=
                                            undefined
                                        ) {
                                            window.webkit.messageHandlers.callbackHandler.postMessage(
                                                "sign-in-from-checkout"
                                            );
                                        }
                                    }
                                } catch (err) {
                                    console.log("error in sending message", err);
                                }
                            }
                            setLoginModal(false)
                            if (loginRedirectURL) {
                                window.open(loginRedirectURL, '_self')
                            } else {
                                if(isMainDomain()){
                                    navigate("/verify-user")// navigate('/login')
                                }else{
                                    navigate("/")
                                }
                                
                                //navigate(routeList.LOGIN_PAGE)
                            }
                        }}
                        isPrimary={true}
                    />
                </Modal.Footer>
            </Modal>
        )
    }

    const scrollToSection = (section) => {

        const sectionTop = document.getElementById(`${section}`).offsetTop;
        window.scrollTo({
            top: sectionTop,
            behavior: "smooth"
        });
    }

    const handleSubmit = async (values, event) => {
        if (enableFormField) {
            // setSubmitForm(false)
            setErrorMsg('')
            console.log(values)
            setPaymentInProcess(true)
            values.piClientSecret = paymentIntentInfo.piClientSecret;
            values.paymentIntentsToken = paymentIntentInfo.paymentIntentsToken;
            stripeRef.current.handleStripeSubmit(values, isLoggedIn, type)
        }
    }

    return (
        <>
            {renderLoginButtonModal()}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={handleSubmit}
                innerRef={formRef}
            >
                {
                    (formik) => {
                        const { handleSubmit, errors, touched, handleChange } = formik;
                        
                        if (formik.isSubmitting) {
                            if (!_.isEmpty(errors)) {
                                if (errors.contactEmail) {
                                    scrollToSection('contactEmail')
                                } else if (errors.firstName) {
                                    scrollToSection('firstName')
                                } else if (errors.addressLine1) {
                                    scrollToSection('addressLine1')
                                } else if (errors.city) {
                                    scrollToSection('city')
                                } else if (errors.phoneNumber) {
                                    scrollToSection('phoneNumber')
                                } else if (errors.postalCode) {
                                    scrollToSection('postalCode')
                                }
                            }
                        }

                        return (
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <div className="col-12 col-lg-9">
                                    <div className="payment-info-details">
                                        <div className="form-group">
                                            <div className="input-text ">
                                                <label
                                                    htmlFor="contactEmail"
                                                    className="input__label"
                                                >
                                                    Contact Email<span>*</span>
                                                </label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        id="contactEmail"
                                                        className="input__field"
                                                        name="contactEmail"
                                                        type="email"
                                                        placeholder="Enter your email"
                                                        required
                                                        autoComplete="off"
                                                        value={formik.values.contactEmail}
                                                        onChange={(e) => {
                                                            contactEmail
                                                                .isValid(e.target.value)
                                                                .then((valid) => {
                                                                    if (valid && !isLoggedIn) {
                                                                        dispatch(
                                                                            checkEmailExists({
                                                                                URL: `${CONFIG.API_URL_REAL_BROKER}${API_LIST.BROKER_API.CHECK_EMAIL_EXISTS}`,
                                                                                payload: {
                                                                                    email: e.target.value
                                                                                },
                                                                                isJSON: true,
                                                                                method: 'post'
                                                                            })
                                                                        )
                                                                    }
                                                                })
                                                            formik.handleChange(e)
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        disabled={isLoggedIn || token}
                                                    />
                                                    {/* <i class="fa-duotone fa-spinner"></i> */}
                                                </div>
                                                {!isLoggedIn && !token && <span className="info-msg">This email id will be use to create your account.</span>}
                                                <span className="error-message">
                                                    {formik.errors.contactEmail ? formik.errors.contactEmail : ""}
                                                </span>
                                            </div>
                                        </div>
                                        {
                                            ((!isLoggedIn && !token) || (isCustomer && paymentIntentInfo.brokerageEmail)) ?
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="brokerageEmail"
                                                            className="input__label"
                                                        >
                                                            Brokerage Email
                                                        </label>
                                                        <Input
                                                            id="brokerageEmail"
                                                            className="input__field"
                                                            name="brokerageEmail"
                                                            type="email"
                                                            placeholder="Enter your brokerage email"
                                                            required
                                                            value={formik.values.brokerageEmail}
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.brokerageEmail ? formik.errors.brokerageEmail : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                :
                                                isCustomer ? "" :
                                                    <div className="form-group">
                                                        <div className="input-text ">
                                                            <label
                                                                htmlFor="brokerageName"
                                                                className="input__label"
                                                            >
                                                                Brokerage Name
                                                            </label>
                                                            <Input
                                                                id="brokerageName"
                                                                className="input__field"
                                                                name="brokerageName"
                                                                type="text"
                                                                placeholder="Enter your brokerage name"
                                                                required
                                                                autoComplete="off"
                                                                value={formik.values.brokerageName}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                disabled={true}
                                                            />
                                                            <span className="error-message">
                                                                {formik.errors.brokerageName ? formik.errors.brokerageName : ""}
                                                            </span>
                                                        </div>
                                                    </div>
                                        }
                                        <div className="user-billing-info">
                                            <div className="billing-title">Billing details</div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group">
                                                <div className="input-text ">
                                                    <label
                                                        htmlFor="province"
                                                        className="input__label"
                                                    >
                                                        Region<span>*</span>
                                                    </label>
                                                    <select
                                                        type="text"
                                                        id="country"
                                                        name="country"
                                                        disabled
                                                        value={formik.values.country}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        className="form-select input_searchfield"
                                                        placeholder=""
                                                    >
                                                        <option value="">Select Country</option>
                                                        {Country.map((country, index) => {
                                                            return (
                                                                <option key={index} value={country.code}>
                                                                    {country.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                    <span className="error-message">
                                                        {formik.errors.country ? formik.errors.country : ""}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="firstName"
                                                            className="input__label"
                                                        >
                                                            Full Name<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="firstName"
                                                            className="input__field"
                                                            name="firstName"
                                                            type="text"
                                                            placeholder="Enter your full name"
                                                            required
                                                            autoComplete="off"
                                                            // value={isLoggedIn ? `${formik.values.firstName} ${formik.values.lastName}` : `${formik.values.firstName}`}
                                                            value={`${formik.values.firstName}${formik.values.lastName ? ` ${formik.values.lastName}` : ""}`}
                                                            onChange={(e) => {
                                                                // formik.handleChange(e)
                                                                if (e.target.value.length > 0) {
                                                                    const name = e.target.value.split(' ');
                                                                    console.log('NAME', name)
                                                                    if (name.length > 1 && !name[1]) {
                                                                        formik.setFieldValue('firstName', name[0] + " ")
                                                                    } else {
                                                                        formik.setFieldValue('firstName', name[0])
                                                                    }
                                                                    // formik.setFieldValue('firstName', name[0])
                                                                    if (name.length > 1 && name[0]) {
                                                                        formik.setFieldValue('lastName', name[1])
                                                                    }
                                                                    formik.setErrors({firstName: false})
                                                                } else {
                                                                    formik.setFieldValue('firstName', "")
                                                                    formik.setFieldValue('lastName', "")
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField || isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.firstName ? formik.errors.firstName : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="lastName"
                                                            className="input__label"
                                                        >
                                                            Last Name<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="lastName"
                                                            className="input__field"
                                                            name="lastName"
                                                            type="text"
                                                            placeholder="Enter your last name"
                                                            required
                                                            autoComplete="off"
                                                            value={formik.values.lastName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField || isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.lastName ? formik.errors.lastName : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="addressLine1"
                                                            className="input__label"
                                                        >
                                                            Address<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="addressLine1"
                                                            className="input__field"
                                                            name="addressLine1"
                                                            type="text"
                                                            placeholder="Enter your address"
                                                            required
                                                            autoComplete="new-password"
                                                            onChange={(e) => {
                                                                formik.handleChange(e)
                                                                if (e.target.value.length > 0) {
                                                                    formik.setErrors({addressLine1: false})
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.addressLine1 ? formik.errors.addressLine1 : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="city"
                                                            className="input__label"
                                                        >
                                                            City<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="city"
                                                            className="input__field"
                                                            name="city"
                                                            value={formik.values.city}
                                                            type="text"
                                                            placeholder="Enter your city"
                                                            required
                                                            autoComplete="new-password"
                                                            onChange={(e) => {
                                                                formik.handleChange(e)
                                                                if (e.target.value.length > 0) {
                                                                    formik.setErrors({city: false})
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.city ? "Please enter a value" : ""}
                                                            {/* {touched.city ? touched.city : ""} */}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="state"
                                                            className="input__label"
                                                        >
                                                            Province<span>*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            id="state"
                                                            name="state"
                                                            value={formik.values.state}
                                                            onChange={(e) => {
                                                                setProvince(e.target.value)
                                                                formik.handleChange(e)
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            className="form-select input_searchfield"
                                                            placeholder=""
                                                            disabled={!enableFormField}
                                                        >
                                                            <option value="">Select Province</option>
                                                            {provinceList.map((province, index) => {
                                                                return (
                                                                    <option key={index} value={province.id}>
                                                                        {province.name}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        <span className="error-message">
                                                            {formik.errors.state ? formik.errors.state : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="postalCode"
                                                            className="input__label"
                                                        >
                                                            Postal code<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="postalCode"
                                                            className="input__field"
                                                            name="postalCode"
                                                            type="text"
                                                            placeholder="Enter your postal code"
                                                            required
                                                            autoComplete="new-password"
                                                            onChange={(e) => {
                                                                formik.handleChange(e)
                                                                if (e.target.value.length > 0) {
                                                                    formik.setErrors({postalCode: false})
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.postalCode ? formik.errors.postalCode : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="phoneNumber"
                                                            className="input__label"
                                                        >
                                                            Phone Number<span>*</span>
                                                        </label>
                                                        {/* <Input
                                                            id="phoneNumber"
                                                            className="input__field"
                                                            name="phoneNumber"
                                                            type="text"
                                                            placeholder="Enter your phone number"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        /> */}
                                                        <PhoneInput
                                                            defaultCountry="CA"
                                                            // value={value}
                                                            // onChange={setValue}
                                                            required
                                                            id="phoneNumber"
                                                            className="input__field"
                                                            name="phoneNumber"
                                                            placeholder="Enter your phone number"
                                                            value={formik.values.phoneNumber}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    console.log(e)
                                                                    // setValue(e)
                                                                    // formik.handleChange(e)
                                                                    formik.setFieldValue('phoneNumber', e)
                                                                } else {
                                                                    formik.setFieldValue('phoneNumber', "")
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        {/* <InputPhone
                                                            country="CA"
                                                            placeholder="Enter phone number"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                            className="input__field"
                                                            name="phoneNumber"
                                                        /> */}
                                                        {/* <InputPhoneComponent
                                                            country="CA"
                                                            placeholder="Enter phone number"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                            className="input__field"
                                                            name="phoneNumber"
                                                        /> */}
                                                        <span className="error-message">
                                                            {formik.errors.phoneNumber ? formik.errors.phoneNumber : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {renderCardElements()}
                                    </div>
                                </div>
                            </form>
                        )
                    }
                }
            </Formik>
        </>
    )
}

export default LeftPanelPaymentSection